// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m-filter-container[data-v-c98f1ec4]{position:absolute;top:2.5rem;left:0;z-index:20;display:flex;width:100%;flex-direction:column;--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity))}@media (min-width:1024px){.m-filter-container[data-v-c98f1ec4]{display:none}}.m-filter-container[data-v-c98f1ec4]{height:calc(100% - 2.5rem)}.season[data-v-c98f1ec4]{display:flex;height:100%;align-items:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
